import React from "react"
import '../Styles/MobileLinks.scss';
import { useState } from "react";
import {AiFillCaretDown} from 'react-icons/ai'

function MobileLinks() {
   const [about, setAbout] = useState(false);
   const [camps, setCamps] = useState(false);

   return (
      <div className="mobileLinksContent">

            <li id="about" onClick={() => setAbout(!about)}>About
            <AiFillCaretDown/>
            {about &&
                  <ul id = "mobileSub1">
                     <li><a href="/history">History</a></li>
                     <li><a href="/mission">Mission</a></li>
                     <li><a href="/goodnews">Good News</a></li>
                     <li><a href="/staff">Staff</a></li>
                     <li><a href="/getinvolved">Get Involved</a></li>
                  </ul>
            }
            </li>

            <li id="camps" onClick={() => setCamps(!camps)}>Camps
            <AiFillCaretDown/>
            {camps && 
                  <ul id="mobileSub2">
                     <li><a href="/adults">Adults</a></li>
                     <li><a href="/deaf">Deaf</a></li>
                     <li><a href="/family">Families</a></li>
                     <li><a href="/juniorhome">Juniors</a></li>
                     <li><a href="/teens">Teens</a></li>
                  </ul>
            }
            </li>

            <div className='regularLinks'>
               <li id="firstLight"><a href="/ministryresources">Resources</a></li>
               <li id="store"><a href="/Contact">Contact</a></li>
               <li id="give"><a href="/adminhome">Admin</a></li>
            </div>
      
      </div>
   )

}

export default MobileLinks;